require('../../../scss/components/duo-selector.scss');
import rwxDuoSelector from 'roseworx/js/components/rwxDuoSelector';

document.getElementById('setValuesDemo').addEventListener('click', ()=>{
	const val = document.getElementById('setValue1Val').value;
	const val2 = document.getElementById('setValue2Val').value;
	const selectedValue = document.getElementById('selectedValue');
	const arr = [{displayName: val, value: val}, {displayName:val2, value: val2}];
	rwxDuoSelector.setValues(arr)
	.then((res)=>{ selectedValue.innerText = `You selected '${res}'` });
});
